import { Container, Image } from '@/components/common/404';
import * as React from 'react';
export default {
  Container,
  Image,
  React
};